import { AxiosResponse } from "axios"
import {
  UploadFileToSFTPRequest,
  ValidationResultModel,
} from "components/models"
import EbateAxios from "queries/ebateAxios"

const importDataUrl = "/api/ImportData"

export const getImportFileTemplate = async (
  exchangeObjectId: number,
  exchangeMappingId: number
) => {
  const url = `${importDataUrl}/GetImportFileTemplate/${exchangeObjectId}/${exchangeMappingId}`
  const { AxiosGet } = EbateAxios()

  return AxiosGet<Blob>(url)
}

export const getMappngImportFileTemplate = async (
  exchangeObjectId: number,
  exchangeMappingId: number,
  importTypeId: number,
  fileId: number
) => {
  const url = `${importDataUrl}/GetMappingImportFileTemplate/${exchangeObjectId}/${exchangeMappingId}/${importTypeId}/${fileId}`
  const { AxiosGet } = EbateAxios()

  return AxiosGet<Blob>(url)
}

export const getSeasonalityImportFileTemplate = async () => {
  const url = `${importDataUrl}/GetSeasonalityImportFileTemplate`
  const { AxiosGet } = EbateAxios()

  return AxiosGet<Blob>(url)
}

export const uploadFileToSFTP = async (
  request: UploadFileToSFTPRequest
): Promise<AxiosResponse<ValidationResultModel>> => {
  const url = `${importDataUrl}/uploadFileToSFTP`
  const { AxiosPost } = EbateAxios()

  return AxiosPost<UploadFileToSFTPRequest, ValidationResultModel>(url, request)
}

export const uploadMappingFile = async (
  request: UploadFileToSFTPRequest
): Promise<AxiosResponse<ValidationResultModel>> => {
  const url = `${importDataUrl}/uploadMappingFile`
  const { AxiosPost } = EbateAxios()

  return AxiosPost<UploadFileToSFTPRequest, ValidationResultModel>(url, request)
}

export const saveMapping = async (
  request: any
): Promise<AxiosResponse<any>> => {
  const url = `${importDataUrl}/SaveMapping`
  const { AxiosPost } = EbateAxios()

  return AxiosPost<any, any>(url, request)
}

export const saveFile = async (request: any): Promise<AxiosResponse<any>> => {
  const url = `${importDataUrl}/SaveFile`
  const { AxiosPost } = EbateAxios()

  return AxiosPost<any, any>(url, request)
}
